module.exports = __webpack_public_path__ + "img/quote.09f90abb.svg";